module.exports = __webpack_public_path__ + "static/media/boss-bar-red-09.153b441b.png";